import {cssTheme} from '@logistics-frontend/blocks'
import {css} from '@logistics-frontend/blocks/theme/css'
import {hex2rgba, spacing} from '@logistics-frontend/blocks/theme/theme'

export const root = css`
  display: flex;
  border-radius: ${spacing(1, 1, 1, 0)};
  align-items: center;
  justify-content: center;
  max-block-size: ${spacing(2.25)};
  background: ${hex2rgba(cssTheme.default.day.background.hex, 0.2)};
  backdrop-filter: blur(80px);
  padding: ${spacing(0.375, 0, 0.375, 0.625)};
  user-select: none;
  pointer-events: none;
`

export const text = css`
  opacity: 0.4;
`

export const icon = css`
  opacity: 0.4;
  inline-size: ${spacing(1.5)};
`
